export default class CAJA1090RequestModel {}
